import React from 'react';
import PasswordReset from '../components/PasswordReset';

const Page = () => <PasswordReset />;

export default Page;
